import { isMobileHomePage, isMobileListingPage, isDesktopHomePage, isDesktopListingPage } from './globals'

import DesktopHome from '@/components/search/DesktopHome.vue'
import DesktopListing from '@/components/search/DesktopListing.vue'
import MobileHome from '@/components/search/MobileHome.vue'
import MobileListing from '@/components/search/MobileListing.vue'
import { OffersListRequest } from '@/modules/api'

/**
 * @param {Element} root 
 */
function createRootElementForSearchBox (root) {
  const result = document.createElement('div')
  result.classList.add('search-container')
  root.insertAdjacentElement('beforebegin', result)
  return result
}

function loadOffersExists () {
  const dataSourceDiv = document.querySelector('.load-offers[data-first-load]')
  return dataSourceDiv && dataSourceDiv.dataset.firstLoad
}

export function init () {
  log.debug('Initializing search component')

  const searchForms = document.querySelectorAll('.main-search')
  const shouldSetListingFilters = loadOffersExists() ? OffersListRequest.shouldSetListingFiltersInSearch() : null
  searchForms.forEach(searchForm => {
    const root = createRootElementForSearchBox(searchForm)
    const form = searchForm.querySelector('form')
    
    if (isMobileHomePage()) new MobileHome({ el: root, propsData: { form } })
    if (isDesktopHomePage()) new DesktopHome({ el: root, propsData: { form } })
    if (isMobileListingPage()) new MobileListing({ el: root, propsData: { form, shouldSetListingFilters } })
    if (isDesktopListingPage()) new DesktopListing({ el: root, propsData: { form, shouldSetListingFilters } })
  })
}



// WEBPACK FOOTER //
// ./src/modules/searchForm.js